import { Check } from 'lucide-react'

// Completion sits on the right, at a small button's height, where the step's
// action would be. An empty circle on the left read as a radio input.
export const StepDone = () => (
  <div className="flex h-8 items-center">
    <div className="flex size-5 items-center justify-center rounded-full bg-green-600">
      <Check className="size-3 text-white" strokeWidth={3} />
      <span className="sr-only">Completed</span>
    </div>
  </div>
)
